<div class="py-2">
    <!-- Source of Income -->
    <div class="mb-3">
      <label for="sourceOfIncome" class="form-label required"
        >What is the source of income?</label
      >
      <select
        id="sourceOfIncome"
        class="form-select"
        v-model="form_data.sourceOfIncome"
      >
        <option value="">Not Selected</option>
        <option v-for="opt in source_options" :key="opt" :value="opt">
          {{ opt }}
        </option>
      </select>
    </div>

    <!-- Customer Income Section -->
    <div class="signio-divider-header" @click="toggle('customer_income')">
      <span class="chevron">{{ collapsed.customer_income ? "▸" : "▾" }}</span>
      <label class="signio-divider-header-title">Customer Income</label>
    </div>
    <transition name="fade">
      <div v-show="!collapsed.customer_income">
        <!-- Remuneration -->
        <div class="category-title">Remuneration</div>
        <div class="row g-3">
          <div
            v-for="field in customer_remuneration"
            :key="field.key"
            class="col-md-4 mb-3"
          >
            <label class="currency-input-label form-label text-xs mb-1">{{ field.question }}</label>
            <div class="mt-1">
              <div class="currency-input-group">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Other Income -->
        <div class="category-title mt-3">Other Income</div>
        <div class="row g-3">
          <div
            v-for="field in customer_other"
            :key="field.key"
            class="col-md-4 mb-3"
          >
            <label class="form-label text-xs mb-1">{{ field.question }}</label>
            <div class="mt-1">
              <div class="currency-input-group">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="on_amount_input(field)"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Other Income Description - Conditionally shown when other income > 0 -->
        <transition name="fade">
          <div class="row g-3 mt-3" v-if="show_customer_other_income_description">
            <div
              v-for="field in customer_text"
              :key="field.key"
              class="col-sm-12 mb-3"
            >
              <label class="form-label text-xs mb-1">
                <i class="fa fa-info-circle text-primary me-1"></i>
                {{ field.question }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :id="field.key"
                v-model="form_data[field.key]"
                placeholder="Please describe your other income source"
              />
              <small class="text-muted">This field is required when you have other income</small>
            </div>
          </div>
        </transition>
        <!-- Totals -->
        <div class="category-title mt-3 d-none">Totals</div>
        <div class="row g-3 d-none">
          <div
            v-for="field in customer_totals"
            :key="field.key"
            class="col-md-4 mb-3"
          >
            <label class="form-label text-xs mb-1">{{ field.question }}</label>
            <div class="mt-1">
              <div class="currency-input-group">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  :value="customer_total"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Spouse Income Section -->
    <div class="signio-divider-header mt-4" v-if="is_married" @click="toggle('spouse_income')">
      <span class="chevron">{{ collapsed.spouse_income ? "▸" : "▾" }}</span>
      <label class="signio-divider-header-title">Spouse Income</label>
    </div>
    <transition name="fade" v-if="is_married">
      <div v-show="!collapsed.spouse_income">
        <!-- Remuneration -->
        <div class="category-title">Remuneration</div>
        <div class="row g-3">
          <div
            v-for="field in spouse_remuneration"
            :key="field.key"
            class="col-md-4 mb-3"
          >
            <label class="form-label text-xs mb-1">{{ field.question }}</label>
            <div class="mt-1">
              <div class="currency-input-group">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="on_amount_input(field)"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Other Income -->
        <div class="category-title mt-3">Other Income</div>
        <div class="row g-3">
          <div
            v-for="field in spouse_other"
            :key="field.key"
            class="col-md-4 mb-3"
          >
            <label class="form-label text-xs mb-1">{{ field.question }}</label>
            <div class="mt-1">
              <div class="currency-input-group">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="on_amount_input(field)"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Spouse Other Income Description - Conditionally shown when spouse other income > 0 -->
        <transition name="fade">
          <div class="row g-3 mt-3" v-if="show_spouse_other_income_description">
            <div
              v-for="field in spouse_text"
              :key="field.key"
              class="col-sm-12 mb-3"
            >
              <label class="form-label text-xs mb-1">
                <i class="fa fa-info-circle text-primary me-1"></i>
                {{ field.question }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :id="field.key"
                v-model="form_data[field.key]"
                placeholder="Please describe your spouse's other income source"
              />
              <small class="text-muted">This field is required when spouse has other income</small>
            </div>
          </div>
        </transition>
        <!-- Totals -->
        <div class="category-title mt-3 d-none">Totals</div>
        <div class="row g-3 d-none">
          <div
            v-for="field in spouse_totals"
            :key="field.key"
            class="col-md-4 mb-3"
          >
            <label class="form-label text-xs mb-1">{{ field.question }}</label>
            <div class="mt-1">
              <div class="currency-input-group">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  :value="spouse_total"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- Submit button -->
    <div class="text-end mt-4">
      <button type="button" @click="previous" class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-1">
        Previous
      </button>
      <button
        type="button"
        @click="submit_section"
        class="btn btn-bg-green text-xs rounded-small shadow-sm"
      >
        Continue
      </button>
    </div>
  </div>